import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  const navLinks = [
    { path: "/", label: "首页" },
    { path: "/category/hot", label: "热门推荐" },
    { path: "/category/new", label: "最新上架" },
    { path: "/category/completed", label: "已完结" },
    { path: "/about", label: "关于我们" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl font-bold transition-colors duration-300 ${
              scrolled || !isHome ? "text-primary-500" : "text-background-50"
            }`}>
              <i className="ri-book-open-line mr-1"></i>
              36漫画
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? "bg-primary-500 text-background-50"
                    : scrolled || !isHome
                      ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                      : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 whitespace-nowrap ${
              scrolled || !isHome
                ? "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                : "text-background-50/80 hover:text-background-50 hover:bg-background-50/10"
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 whitespace-nowrap ${
              scrolled || !isHome
                ? "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                : "text-background-50/80 hover:text-background-50 hover:bg-background-50/10"
            }`}>
              <i className="ri-user-line text-lg"></i>
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors whitespace-nowrap ${
              scrolled || !isHome
                ? "text-foreground-700 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}